import { useState } from "react";
import { valuesProps } from "types/paymentMethods";
import { initialValues } from "utils/countryAddressList";

interface UseCardStateReturn {
  cardNumber: string;
  iconType: string;
  values: valuesProps;
  isDateErr: boolean;
  cardErrMsg: string;
  isErr: number;
  setCardNumber: (num: string) => void;
  setIconType: (type: string) => void;
  setValues: (values: valuesProps) => void;
  setIsDateErr: (err: boolean) => void;
  setCardErrMsg: (msg: string) => void;
  setIsErr: (err: number) => void;
  resetCardState: () => void;
}

export const useCardState = (): UseCardStateReturn => {
  const [cardNumber, setCardNumber] = useState<string>("");
  const [iconType, setIconType] = useState<string>("");
  const [values, setValues] = useState<valuesProps>(initialValues);
  const [isDateErr, setIsDateErr] = useState<boolean>(false);
  const [cardErrMsg, setCardErrMsg] = useState<string>("");
  const [isErr, setIsErr] = useState(-1);

  const resetCardState = () => {
    setCardNumber("");
    setIconType("");
    setValues(initialValues);
    setIsDateErr(false);
    setCardErrMsg("");
    setIsErr(-1);
  };

  return {
    cardNumber,
    iconType,
    values,
    isDateErr,
    cardErrMsg,
    isErr,
    setCardNumber,
    setIconType,
    setValues,
    setIsDateErr,
    setCardErrMsg,
    setIsErr,
    resetCardState,
  };
};
